<template>
  <div>
    <div class="col-md-3 px-0">
      <img class="img-fluid" id="logo" src="@/assets/logo.png">
    </div>
    <h1 class="mt-3">
      Error: 404. Not found!
    </h1>
    <p class="mt-5">The page you are seeking does not exist.  Please confirm you have entered the URL properly. If you continue having problems, please contact your account representative.</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue